import { faFilter, faWarning } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Box, Tabs as VaporTabs, Tab, Tooltip } from '@vapor/material'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { ReservationHeaderTab } from '../types/reservation-detail.types'

export type TabsProps = {
  setActiveTab: (activeTab: number) => void
  activeTab: number
  showFilterIcon: boolean
  showMessagesWarningIcon: boolean
  hourlyResourceTypeExists: boolean
}

export function Tabs({ setActiveTab, activeTab, showFilterIcon, showMessagesWarningIcon, hourlyResourceTypeExists }: TabsProps) {
  const { t } = useTranslation()

  const filterIcon = useMemo(
    () =>
      showFilterIcon ? (
        <Tooltip title={t('pms.booking.reservation.tab.messages_icon_tooltip')}>
          <FontAwesomeIcon icon={faFilter} />
        </Tooltip>
      ) : undefined,
    [showFilterIcon],
  )
  const messagesWarningIcon = useMemo(() => (showMessagesWarningIcon ? <FontAwesomeIcon icon={faWarning} /> : undefined), [showMessagesWarningIcon])

  return (
    <div style={{ width: '100%' }}>
      <Box sx={{ '& .MuiTabs-root': { borderBottom: '0px !important' } }}>
        <VaporTabs
          {...{ size: 'small', textColor: 'secondary' }}
          value={activeTab}
          onChange={(event, newValue) => setActiveTab(newValue)}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
        >
          <Tab
            label={t('pms.booking.reservation.tab.reserved_resources')}
            value={ReservationHeaderTab.RESERVED_RESOURCES}
            icon={filterIcon}
            iconPosition="end"
            sx={{ minHeight: '48px' }}
            {...tabProps(0)}
          />
          {hourlyResourceTypeExists && (
            <Tab
              label={t('pms.booking.reservation.tab.reserved_resources_time')}
              value={ReservationHeaderTab.RESERVED_RESOURCES_HOURLY}
              icon={filterIcon}
              iconPosition="end"
              sx={{ minHeight: '48px' }}
              {...tabProps(1)}
            />
          )}
          <Tab label={t('pms.booking.reservation.tab.bills')} value={ReservationHeaderTab.BILLS} icon={filterIcon} iconPosition="end" sx={{ minHeight: '48px' }} {...tabProps(2)} />
          <Tab label={t('pms.booking.reservation.tab.messages')} value={ReservationHeaderTab.MESSAGES} icon={messagesWarningIcon} iconPosition="end" sx={{ minHeight: '48px' }} {...tabProps(3)} />
          <Tab label={t('pms.booking.reservation.tab.attaches')} value={ReservationHeaderTab.ATTACHES} sx={{ minHeight: '48px' }} {...tabProps(4)} />
        </VaporTabs>
      </Box>
    </div>
  )
}

function tabProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  }
}

interface TabPanelProps {
  children?: React.ReactNode
  panelIndex: number
  activeTab: number
}

export function TabPanel(props: TabPanelProps) {
  const { children, activeTab, panelIndex } = props

  return (
    <div //
      // role="tabpanel"
      // id={`simple-tabpanel-${panelIndex}`}
      // aria-labelledby={`simple-tab-${panelIndex}`}
      // hidden={activeTab !== panelIndex}
      style={{ display: activeTab !== panelIndex ? 'none' : undefined }}
    >
      {activeTab === panelIndex && children}
      {/* {children} */}
    </div>
  )
}
